if (!customElements.get('single-line-product-title')) {
  customElements.define('single-line-product-title', class extends HTMLElement {
    connectedCallback() {
      this.fit = () => {
        const title = this.querySelector('h1');
        if (!title || !this.clientWidth) return;
        title.style.fontSize = '';
        const size = parseFloat(getComputedStyle(title).fontSize);
        const range = document.createRange();
        range.selectNodeContents(title);
        const width = range.getBoundingClientRect().width;
        if (width > this.clientWidth) {
          title.style.fontSize = `${size * (this.clientWidth - 1) / width}px`;
        }
      };
      this.observer = new ResizeObserver(() => {
        if (this.lastWidth !== this.clientWidth) {
          this.lastWidth = this.clientWidth;
          this.fit();
        }
      });
      this.observer.observe(this);
      window.addEventListener('resize', this.fit);
      document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
      this.fit();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.fit);
    }
  });
}
